import { render } from "./DevServer.vue?vue&type=template&id=02493586&scoped=true"
import script from "./DevServer.vue?vue&type=script&lang=js"
export * from "./DevServer.vue?vue&type=script&lang=js"

import "./DevServer.vue?vue&type=style&index=0&id=02493586&scoped=true&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02493586"]])

export default __exports__